import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { RECORD_DELETED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { DELETE_CATEGORY } from 'pages/Products/ProductsGraphQL';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { Col, Label, Row } from 'reactstrap';
import DebounceTextInput from 'components/DebounseTextInput';
import Select from 'react-select';
import { axiosGetAPI } from 'services';
import { authContext } from 'contexts/AuthContext';
import SubCategoryTable from './components/SubCategoryTable';
import AddEditSubCategory from './components/AddEditSubCategory';

const SubCategory = () => {
  const { auth } = useContext(authContext);

  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });

  const [deleteRowId, setDeleteRowId] = useState('');
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    id: 'all',
    name: 'All',
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const resp = await axiosGetAPI(
          `${process.env.REACT_APP_REST_API_ENDPOINT}grades/get-sub-category-products`,
          auth,
        );
        setProducts(resp?.data || []);
      } catch (error) {
        console.error(error);
      }
    };
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchString, setSearchString] = useState('');

  const handleChange = (value) => {
    setSearchString(value);
  };

  const [deleteCategory] = useMutation(DELETE_CATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        return message;
      });
    },
  });

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteCategory({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const toggleAddRecord = (row, type) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };
  const handleClickEdit = (val, type) => {
    setAddRecord({ status: true, row: val, type });
  };

  const handleSelectOption = (value) => {
    setSelectedOption(value);
  };

  return (
    <div>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <FSBModal
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Sub Category`}
        closeButtonLabel=""
        confirmButtonLabel=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        message=""
        modalClass="right-drawer"
      >
        <AddEditSubCategory
          toggleAddRecord={toggleAddRecord}
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
        />
      </FSBModal>

      <div className="products-toolbar">
        <Row>
          <Col
            sm={3}
            className="text-start filter-row-ui products-filter-row"
            style={{ top: '0px', left: '0px', right: 'auto' }}
          >
            <div className="form-group">
              <Label>Product</Label>
              <Select
                name="Product"
                options={
                  Array.isArray(products)
                    ? [{ id: 'all', name: 'All' }, ...products]
                    : []
                }
                getOptionLabel={(product) => product?.name}
                getOptionValue={(product) => product?.id}
                placeholder="Product"
                classNamePrefix="react-select"
                value={selectedOption}
                // defaultMenuIsOpen
                onChange={handleSelectOption}
              />
            </div>
          </Col>
          <Col sm={3} className="text-end">
            <DebounceTextInput
              onInputChange={handleChange}
              delay={500} // Set your desired delay in milliseconds
              value={searchString}
              placeholder="Search by sector"
              positionTop="-52px"
              positionRight="95px"
              classWrapper="products-search"
            />
          </Col>
        </Row>
        <SubCategoryTable
          searchString={searchString}
          selectedOption={selectedOption}
          handleClickEdit={handleClickEdit}
          toggleDeleteRecord={toggleDeleteRecord}
          toggleAddRecord={toggleAddRecord}
        />
      </div>
    </div>
  );
};

export default SubCategory;
